import { ErrorCode } from "~/modules/error/ErrorCode/ErrorCodes";
import { FlexSdkError } from "~/modules/error/FlexSdkError/FlexSdkError";

import { FlexSdkErrorMetadata } from "~/modules/error/FlexSdkErrorMetadata/FlexSdkErrorMetadata";
import ErrorReporter from "~/modules/reporter/ErrorReporter";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";

export interface ErrorResponse {
    code?: number;
    message?: string;
}

export function createFlexSdkError(ctx: ContextManager) {
    return (errorCode: number, metadata?: FlexSdkErrorMetadata, message?: string, cause?: any): FlexSdkError => {
        
        if (cause instanceof FlexSdkError) {
            return cause;
        }

        const err = new FlexSdkError(errorCode, metadata, message, cause);

        ctx.retrieveInstanceOf(ContextInstance.ErrorReporter, ErrorReporter).publishTelemetryError(err);
        return err;
    };
}



export function throwFlexSdkError(ctx: ContextManager) {
    return (errorCode: number, metadata?: FlexSdkErrorMetadata, message?: string, cause?: any): never => {
        throw createFlexSdkError(ctx)(errorCode, metadata, message, cause);
    };
}

export function throwFlexSdkErrorFromErrorResponse(ctx: ContextManager) {
    return (errorResponse: ErrorResponse, metadata?: FlexSdkErrorMetadata): void => {
        if (errorResponse instanceof FlexSdkError) {
            throw errorResponse;
        }
        const errorCode = errorResponse.code ?? ErrorCode.UnknownError;
        throwFlexSdkError(ctx)(errorCode, metadata, errorResponse.message);
    };
}

export function throwFlexSdkErrorFromResponse(ctx: ContextManager) {
    return async (response: Response, metadata?: FlexSdkErrorMetadata, message?: string): Promise<void> => {
        const errorResponse: ErrorResponse = (await response.json()) as ErrorResponse;
        errorResponse.message = message ?? errorResponse.message;
        throwFlexSdkErrorFromErrorResponse(ctx)(errorResponse, metadata);
    };
}
